export default __webpack_public_path__ + "static/media/profile-info.7ac61cc5.png";